import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-useful-links',
    templateUrl: './useful-links.component.html',
    styleUrls: ['./useful-links.component.scss'],
    standalone: false
})
export class UsefulLinksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
